import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';

import { NextUIProvider } from '@nextui-org/react';
import { CacheProvider, ThemeProvider } from '@emotion/react';
import { prefixer } from 'stylis';
import { createTheme } from '@mui/material';
import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';

import ScrollToTop from '../components/ScrollToTop';
import SpinnerFullPage from '../components/loadingPage/SpinnerFullPage';

import { HelmetProvider } from 'react-helmet-async';
import RoutesC from './Routes';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
// React Query settings
const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 0 } } });

// Create rtl cache
const cacheRtl = createCache({ key: 'muirtl', stylisPlugins: [prefixer, rtlPlugin] });

const theme = createTheme({ typography: { fontFamily: 'Noto Kufi Arabic, Cairo, sans-serif' } });

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CacheProvider value={cacheRtl}>
                <NextUIProvider>
                    <QueryClientProvider client={queryClient}>
                        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
                        <HelmetProvider>
                            <BrowserRouter>
                                <ScrollToTop />
                                <Suspense fallback={<SpinnerFullPage />}>
                                    <RoutesC />
                                </Suspense>
                            </BrowserRouter>
                        </HelmetProvider>

                        {/* Toaster Configrations  */}
                        <Toaster
                            position="top-center"
                            gutter={12}
                            containerStyle={{ margin: '8px' }}
                            toastOptions={{
                                success: { duration: 3000 },
                                error: { duration: 5000 },
                                style: {
                                    fontSize: '16px',
                                    maxWidth: '500px',
                                    padding: '16px 24px',
                                    backgroundColor: 'white',
                                    color: 'black',
                                },
                            }}
                        />
                    </QueryClientProvider>
                </NextUIProvider>
            </CacheProvider>
        </ThemeProvider>
    );
}

export default App;
